import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MaterialAmountState, MATERIAL_AMOUNT_KEY, selectAllMaterialAmounts, selectMaterialAmountEntities, selectMaterialAmountFetched, selectMaterialAmountLatestUpdatedAt } from '../reducers/material-amount.reducers';
import {getWarehouseMovementDictionary} from './warehouse-movement.selector';

const selectState = createFeatureSelector<MaterialAmountState>(MATERIAL_AMOUNT_KEY);

export const getMaterialAmountDictionary = createSelector(selectState, selectMaterialAmountEntities);
export const getMaterialAmounts = createSelector(selectState, selectAllMaterialAmounts);
export const getMaterialAmountsFetched = createSelector(selectState, selectMaterialAmountFetched);
export const getMaterialAmountLatestUpdatedAt = createSelector(selectState, selectMaterialAmountLatestUpdatedAt);

export const getMaterialAmountByMaterialId = (props: { id: number }) => createSelector(getMaterialAmounts, (amounts) => amounts.filter(a => a.MaterialId === props.id));

